import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '2025—2026“十大重庆经济年度人物”评选';
const baseUrl = '20260730JJRW';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/rules`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'newsTwo',
      name: `${baseUrl}-newsTwo`,
      component: () => import('./pages/NewsTwo.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'newsMain',
      name: `${baseUrl}-newsMain`,
      component: () => import('./pages/NewsMain.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rules',
      name: `${baseUrl}-rules`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'apply',
      name: `${baseUrl}-apply`,
      component: () => import('./pages/Apply.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
